import React from "react";
import CalenderIcon from "../../../assets/images/CalenderIcon";

export const CustomDateInput = React.forwardRef(
  ({ value, onClick, placeholder }: any, ref: any) => {
    return(
    <div
      className="flex items-center justify-between w-full p-4 bg-transparent rounded-2xl cursor-pointer "
      onClick={onClick}
      ref={ref}
    >
      <input
        type="text"
        value={value}
        readOnly
        placeholder={placeholder}
        className="w-full text-black focus:outline-none placeholder:text-gray-400 bg-white resize-none leading-tight "
      />
      <div className="flex-shrink-0 ml-2 bg-transparent pl-[8vw] ">
        <CalenderIcon />
      </div>
    </div>
  )}
);